module.exports = __webpack_public_path__ + "media/images/form_component_sprite_small-8e680e7b840fefd68eb27781c22ebe0b.png";